import { AppReducer } from './app-reducer';
import { InitialState } from '../state';

export const GetOrgCheckReducer: AppReducer<'GetOrgCheck'> = (
    state = InitialState.GetOrgCheck,
    action
): typeof state => {
    switch (action.type) {
        case 'GetOrgCheck/Started':
            return {
                ...state,
                getOrgCheckLoading: true,
                getOrgCheckSuccess: false,
            };

        case 'GetOrgCheck/Succeeded':
            return {
                ...state,
                getOrgCheckLoading: false,
                getOrgCheckSuccess: true,
            };

        case 'GetOrgCheck/Failed':
            return {
                ...state,
                getOrgCheckLoading: false,
                getOrgCheckSuccess: false,
                // errorCode: action.payload.errorCode,
            };
        case 'GetOrgCheck/Unmounted':
            return {
                ...state,
                getOrgCheckLoading: false,
                getOrgCheckSuccess: false,
                loading: false,
                success: false,
                // errorCode: '',
            };

        default:
            return state;
    }
};
